import moment from 'moment';

export function getTimeDiff(from?: string, to?: string) {
  if (!to) {
    return '—';
  }
  return from && to && moment(to).from(from, true);
}
